/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import "./App.css";
import { Home } from "./pages/home";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { Mobile } from "./pages/mobile";
import { Test } from "./pages/test";
import { MobileStatic } from "./pages/mobileStatic";
import { Catalog } from "./pages/catalog";
import { HomeV2 } from "./pages/homeV2";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Catalog />,
  },
  {
    path: "/test",
    element: <Test />,
  },
  {
    path: "/static",
    element: <MobileStatic />,
  },
  {
    path: "/mobile",
    element: <Mobile />,
  },
  {
    path: "/v2",
    element: <HomeV2 />,
  },
]);

function App() {
  return (
    <div className="App">
      {/* <Home /> */}
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
